import { render } from "./MyRoutes.vue?vue&type=template&id=29eb6df4&scoped=true"
import script from "./MyRoutes.vue?vue&type=script&lang=js"
export * from "./MyRoutes.vue?vue&type=script&lang=js"

import "./MyRoutes.vue?vue&type=style&index=0&id=29eb6df4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29eb6df4"]])

export default __exports__